import { Spinner } from "@/components/Spinner";

export function LoadingPage() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <Spinner className="size-8 border-primary" />
    </div>
  );
}
